import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_RECOMMENDATIONS } from "../domain";

import { recommendationsApi } from "@api/services";
import { roleGuard } from "@api";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent];

const setRecommendationNotRelevant = async (
  recommendationId: number,
): Promise<void> => {
  recommendationsApi.recommendationsControllerSetRecommendationNotRelevant(
    recommendationId,
  );
};

export const useSetRecommendationNotRelevant = (
  user: UserProfileDto | null,
): {
  setRecommendationNotRelevant: UseMutateFunction<void, Error, number, unknown>;
  setRecommendationNotRelevantEnabled: boolean;
  isSuccessRecommendationNotRelevant: boolean;
  isPendingRecommendationNotRelevant: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_RECOMMENDATIONS],
    mutationFn: enabled ? setRecommendationNotRelevant : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_RECOMMENDATIONS] });
    },
  });

  return {
    setRecommendationNotRelevant: mutate,
    setRecommendationNotRelevantEnabled: enabled,
    isSuccessRecommendationNotRelevant: isSuccess,
    isPendingRecommendationNotRelevant: isPending,
  };
};
